// antd ships no sparkle, and this is the one place that marks a suggestion as AI-generated.
export default function SparkleIcon() {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true">
      <path d="M9.4 1.6 10.5 4.6 13.5 5.7 10.5 6.8 9.4 9.8 8.3 6.8 5.3 5.7 8.3 4.6Z" />
      <path d="M4.2 9 4.9 10.9 6.8 11.6 4.9 12.3 4.2 14.2 3.5 12.3 1.6 11.6 3.5 10.9Z" />
    </svg>
  );
}
